import React from 'react';
import ScrollToTop from 'components/scroll-to-top';
import ProductsList from 'components/products-list';
import Disclaimer from 'components/disclaimer';
import HomeVideo from './home-video';
import HomeDiscover from './home-discover';
import HomeStories from './home-stories';
import HomeSubscriptions from './home-subscriptions';
import './style.css';

const HomePage = () => (
  <div className="l-home-page">
    <ScrollToTop />
    <div className="home-intro">
      <div className="container">
        <div className="row">
          <div className="col-sm">
            <Disclaimer textAlign="center">
              <h1>
                Breathe in knowledge.
              </h1>
              <p>
                Air quality knowledge for informed sustainable decisions.
                <br />
                Driven by science and technology and delivered by the lead providers.
              </p>
            </Disclaimer>
          </div>
        </div>
      </div>
      <div className="video-section">
        <div className="container">
          <div className="row">
            <div className="col-sm">
              <HomeVideo />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="discover-section">
      <HomeDiscover />
    </div>
    <div className="products-section">
      <div className="container">
        <div className="row">
          <div className="col-sm">
            <div className="rectangle" />
            <h2>Our products</h2>
            <ProductsList />
          </div>
        </div>
      </div>
    </div>
    <div className="subscriptions-section">
      <HomeSubscriptions />
    </div>
    <div className="stories-section">
      <div className="container">
        <div className="row">
          <div className="col-sm">
            <div className="rectangle" />
            <h2>Stories</h2>
            <HomeStories />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/home/index.js